import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import smallfish from "../../../assets/images/smallfish.jpg";

const ColorButton = styled(Button)(() => ({
  color: "#fff",
  width: 200,
  height: 65,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#3E4095",
  borderColor: "#3E4095",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#00AEEF",
    borderColor: "#00AEEF",
  },
}));

const About = () => {
  return (
    <Box
      sx={{
        position: "relative",
        "&::after": {
          position: "absolute",
          content: '""',
          width: "30%",
          zIndex: 1,
          top: 0,
          right: 0,
          height: "20%",
          backgroundSize: "18px 18px",
          backgroundImage: `radial-gradient(${"#00AEEF"} 20%, transparent 30%)`,
          opacity: 0.1,
        },
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          sm={5}
          margin={{ xs: "25% 0% 0% 0%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "105vh", sm: "750px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={smallfish}
            alt={"Fishery"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          padding={{ xs: "30% 0%", sm: "4% 0% 3% 6%" }}
          marginBottom={{ xs: "0%", sm: "5%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={700}
            textAlign={"left"}
            color={"#000"}
            paddingBottom={"1%"}
          >
            Addressing the production of good quality fish in Nigeria.
          </Typography>
          <Typography
            variant={"h3"}
            fontWeight={900}
            textAlign={"left"}
            color={"#00AEEF"}
            paddingBottom={"1%"}
          >
            <Typography
              component={"span"}
              variant={"h3"}
              color="#3E4095"
              fontWeight={900}
            >
              Who {""}
            </Typography>
            We Are
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "1% 0%", sm: "0% 0%" }}
            lineHeight={1.5}
          >
            Aquatic Hub Afrique Network is an offshoot of Fish Shoal Nigeria.
            Fish Shoal Nigeria (Trading Arm of Aquatic Hub Afrique) was founded
            in 2006 and incorporated in 2011, solely to address the production
            of good quality fish in Nigeria.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "2% 0%" }}
            lineHeight={1.5}
          >
            Aquatic Hub exists to teach skills that would in turn encourage
            farmers to utilize Good Aquaculture Practices (GAPs) in bridging the
            gaps in the African aquaculture space. Also, our rich expertise in
            facilitating Enterprise Development programs has given birth to new
            SMEs across Nigeria.
          </Typography>
          <Box marginTop={"4%"}>
            <ColorButton
              component={"a"}
              variant="contained"
              size="medium"
              href={"/about-us"}
            >
              Read More
            </ColorButton>
          </Box>
          <Grid item xs={12} marginTop={{ xs: "10%", sm: "4%" }}>
            <Divider color={"#fff"} />
          </Grid>
          <Grid container marginTop={{ xs: "10%", sm: "4%" }}>
            <Grid
              items
              xs={12}
              sm={4}
              textAlign={"center"}
              paddingBottom={{ xs: "10%", sm: "0%" }}
              paddingRight={{ xs: "0%", sm: "3%" }}
            >
              <Typography
                variant={"h3"}
                color={"#00AEEF"}
                fontWeight={700}
                paddingBottom={"2%"}
              >
                <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                  {({ isVisible }) => (
                    <div style={{ height: 55 }}>
                      {isVisible ? (
                        <CountUp
                          start={0}
                          end={38}
                          duration={1}
                          useEasing={true}
                        />
                      ) : null}
                    </div>
                  )}
                </VisibilitySensor>
              </Typography>
              <Typography variant={"h6"} color={"#3E4095"} fontWeight={700}>
                Development Partners
              </Typography>
              <Typography variant={"body1"} color={"#4f4f4f"} fontWeight={400}>
                Aquatic Hub Afrique has partnered with several organizations
                across Africa in a bid to ensure that our vision is fulfilled.
              </Typography>
            </Grid>
            <Grid
              items
              xs={12}
              sm={4}
              textAlign={"center"}
              paddingBottom={{ xs: "10%", sm: "0%" }}
              paddingRight={{ xs: "0%", sm: "2%" }}
            >
              <Typography
                variant={"h3"}
                color={"#00AEEF"}
                fontWeight={700}
                paddingBottom={"2%"}
              >
                <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                  {({ isVisible }) => (
                    <div style={{ height: 55 }}>
                      {isVisible ? (
                        <CountUp
                          start={0}
                          end={76020}
                          duration={5}
                          useEasing={true}
                        />
                      ) : null}
                    </div>
                  )}
                </VisibilitySensor>
              </Typography>
              <Typography variant={"h6"} color={"#3E4095"} fontWeight={700}>
                Training Applicants
              </Typography>
              <Typography variant={"body1"} color={"#4f4f4f"} fontWeight={400}>
                We receive applications all year round but not every applicants
                is admitted due to the lags in meeting our selection criteria.
              </Typography>
            </Grid>
            <Grid
              items
              xs={12}
              sm={4}
              textAlign={"center"}
              paddingBottom={{ xs: "10%", sm: "0%" }}
              paddingLeft={{ xs: "0%", sm: "2%" }}
            >
              <Typography
                variant={"h3"}
                color={"#00AEEF"}
                fontWeight={700}
                paddingBottom={"2%"}
              >
                <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
                  {({ isVisible }) => (
                    <div style={{ height: 55 }}>
                      {isVisible ? (
                        <CountUp
                          start={0}
                          end={42853}
                          duration={5}
                          useEasing={true}
                        />
                      ) : null}
                    </div>
                  )}
                </VisibilitySensor>
              </Typography>
              <Typography variant={"h6"} color={"#3E4095"} fontWeight={700}>
                Trained and Certified
              </Typography>
              <Typography variant={"body1"} color={"#4f4f4f"} fontWeight={400}>
                All trainees are well trained in line with best practices and we
                have a 100% record of graduation upon admission.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={5}
          margin={{ xs: "5% 0% 0% 0%", sm: "0%" }}
          display={{ xs: "block", sm: "none" }}
        >
          <Box
            component="img"
            height={{ xs: "105vh", sm: "95vh" }}
            width={{ xs: "100%", sm: "100%" }}
            src={smallfish}
            alt={"Fishery"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default About;
